export const columns = [
    {
        Header: 'First Name',
        accessor: 'first_name',
    },
    {
        Header: 'Last Name',
        accessor: 'last_name',
    },
    {
        Header: 'Earned',
        accessor: 'earned',
        disableSortBy: true,
    },
];